export default __webpack_public_path__ + "static/media/ai-brain.148765e6.png";